import React, { useState, useEffect } from 'react';
import './App.css';

/* -------- Constants -------- */
const WHATSAPP_TEXT_URL =
  'https://wa.me/13059106323?text=' +
  encodeURIComponent(
    'Olá Janice! Gostaria de agendar uma avaliação de organização.'
  );
const INSTAGRAM_URL = 'https://www.instagram.com/janicemaakaroun';
const EMAIL_ADDRESS = 'contato@janicemaakaroun.com';
const EMAIL_URL =
  'mailto:contato@janicemaakaroun.com?subject=' +
  encodeURIComponent('Avaliação de organização — Janice Maakaroun') +
  '&body=' +
  encodeURIComponent(
    'Olá Janice,\n\nGostaria de agendar uma avaliação de organização. Aguardo retorno.\n\nAtenciosamente,'
  );

/* -------- Real Janice Maakaroun image library -------- */
const A = (slug) =>
  `https://customer-assets.emergentagent.com/job_janice-premium/artifacts/${slug}`;

const IMG = {
  // Hero & Sobre
  heroCloset: A('wxqq1uwy_HERO%20JANICE.png'), // imagem original do hero (Janice no closet luxury)
  janice: A('m6cztyqr_WhatsApp%20Image%202026-05-04%20at%203.35.49%20PM.jpeg'), // foto Janice
  // Serviços
  servicoResidencial: '/service-residencial.jpg', // closet residencial luxury (gerado)
  servicoCloset: '/service-closet.jpg', // closet hanging gradiente (gerado)
  servicoBolsasSapatos: '/service-bolsas.jpg', // bolsas, sapatos, acessórios luxury (gerado)
  servicoGavetas: '/service-gavetas.jpg', // gaveta organizada centered (gerado)
  servicoMudancas: '/service-mudancas.jpg', // pós-mudança setup finalizado (gerado)
  servicoEmpresarial: A('ch8gj3d7_WhatsApp%20Image%202026-05-04%20at%203.35.52%20PM%20%283%29.jpeg'), // gaveta bambu
  // Portfólio (12 — todos gerados editorial luxury)
  portClosetGradiente: '/port-closets.jpg',
  portCamisasVertical: '/port-camisas.jpg',
  portGravatas: '/port-gravatas.jpg',
  portJoias: '/port-joias.jpg',
  portBolsas: A('k5p5yngc_WhatsApp%20Image%202026-05-04%20at%203.35.52%20PM%20%285%29.jpeg'),
  portSapatos: '/port-sapatos.jpg',
  portCintos: '/port-cintos.jpg',
  portMaquiagem: '/port-maquiagem.jpg',
  portCozinha: '/port-cozinha.jpg',
  portDespensa: '/port-despensa.jpg',
  portTalheres: '/port-talheres.jpg',
  portLoucas: A('hh1vanr0_WhatsApp%20Image%202026-05-04%20at%203.35.54%20PM%20%284%29.jpeg'),
  portBanheiro: '/port-banheiro.jpg',
  portBebe: A('10b9ulj2_WhatsApp%20Image%202026-05-04%20at%203.35.55%20PM.jpeg'),
  portBrinquedos: A('4e4bb4sx_WhatsApp%20Image%202026-05-04%20at%203.35.53%20PM%20%282%29.jpeg'),
  portMudancas: A('b2iaiff5_WhatsApp%20Image%202026-05-04%20at%203.35.53%20PM%20%283%29.jpeg'),
  portEscritorio: '/port-escritorio.jpg',
  portGaragem: A('bn2w8sen_WhatsApp%20Image%202026-05-04%20at%203.35.53%20PM.jpeg'),
  // Antes & Depois
  beforeAfterClosetCama: A('6sp0m7ek_WhatsApp%20Image%202026-05-04%20at%203.35.51%20PM%20%281%29.jpeg'),
  beforeAfterGeladeira: '/before-after-geladeira.jpeg',
};

/* -------- Icons -------- */
const IconWhats = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M20.52 3.48A11.78 11.78 0 0 0 12.06 0C5.5 0 .2 5.3.2 11.86a11.8 11.8 0 0 0 1.6 5.94L0 24l6.36-1.66a11.84 11.84 0 0 0 5.7 1.45h.01c6.56 0 11.87-5.3 11.87-11.86 0-3.17-1.23-6.15-3.42-8.45ZM12.07 21.5h-.01a9.64 9.64 0 0 1-4.92-1.35l-.35-.21-3.78.99 1.01-3.68-.23-.38a9.64 9.64 0 0 1-1.48-5.14c0-5.34 4.35-9.68 9.7-9.68a9.65 9.65 0 0 1 6.85 2.84 9.6 9.6 0 0 1 2.83 6.85c0 5.35-4.35 9.76-9.62 9.76Zm5.56-7.26c-.3-.15-1.8-.89-2.08-.99-.28-.1-.48-.15-.68.15s-.78.99-.96 1.19c-.18.2-.35.22-.65.07-.3-.15-1.28-.47-2.45-1.51-.91-.81-1.52-1.81-1.7-2.11-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.68-1.64-.93-2.25-.25-.59-.5-.51-.68-.52l-.58-.01c-.2 0-.53.07-.8.38s-1.05 1.02-1.05 2.5 1.08 2.9 1.23 3.1c.15.2 2.12 3.24 5.15 4.54.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.8-.74 2.05-1.45.25-.71.25-1.31.18-1.44-.08-.13-.28-.2-.58-.35Z"
      fill="currentColor"
    />
  </svg>
);

const IconInsta = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="17.3" cy="6.7" r="1" fill="currentColor" />
  </svg>
);

const IconArrow = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5 12h14M13 5l7 7-7 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconMail = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M3 7l9 6 9-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconMenu = ({ open, size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    {open ? (
      <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    ) : (
      <>
        <path d="M4 7h16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M4 12h16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M4 17h16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </>
    )}
  </svg>
);

const IconPlus = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

/* -------- Monogram mark -------- */
const Monogram = ({ size = 44 }) => (
  <div
    className="flex items-center justify-center rounded-full flex-shrink-0"
    style={{
      width: size,
      height: size,
      background: 'linear-gradient(135deg, #e5cf9a 0%, #c9a86a 50%, #a88851 100%)',
      boxShadow: '0 6px 14px -6px rgba(201,168,106,0.7), inset 0 1px 0 rgba(255,255,255,0.4)',
    }}
  >
    <span
      className="font-serif"
      style={{
        color: '#2a2623',
        fontSize: size * 0.44,
        fontWeight: 600,
        letterSpacing: '0.02em',
        fontStyle: 'italic',
      }}
    >
      JM
    </span>
  </div>
);

/* -------- Reveal (CSS-only fade up) -------- */
const Reveal = ({ children, className = '', delay = 0 }) => (
  <div
    className={`reveal ${className}`}
    style={delay ? { animationDelay: `${delay}ms` } : undefined}
  >
    {children}
  </div>
);

/* -------- Smart image with elegant fallback -------- */
const SmartImage = ({ src, alt, className, loading = 'lazy', objectPosition, decoding = 'async' }) => {
  const [errored, setErrored] = useState(false);
  if (errored || !src) {
    return (
      <div
        className={className}
        style={{
          background:
            'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.7), transparent 50%),' +
            'linear-gradient(135deg, #efe7d8 0%, #e3d5b8 55%, #d9bf8a 100%)',
        }}
      />
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading={loading}
      decoding={decoding}
      style={{
        objectPosition: objectPosition || 'center',
        imageRendering: 'auto',
      }}
      onError={() => setErrored(true)}
    />
  );
};

/* -------- Header -------- */
const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { label: 'Sobre', href: '#sobre' },
    { label: 'Serviços', href: '#servicos' },
    { label: 'Portfólio', href: '#portfolio' },
    { label: 'Antes & Depois', href: '#antes-depois' },
    { label: 'Benefícios', href: '#beneficios' },
    { label: 'Atendimento', href: '#onde-atendemos' },
    { label: 'FAQ', href: '#faq' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'header-scrolled py-3' : 'py-5'
      }`}
    >
      <div className="container-lux flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-3 md:gap-4 group" aria-label="Janice Maakaroun">
          <Monogram size={scrolled ? 42 : 48} />
          <div className="leading-tight">
            <div
              className="font-serif font-medium transition-all"
              style={{
                color: 'var(--warm-charcoal)',
                letterSpacing: '0.01em',
                fontSize: scrolled ? '1.35rem' : '1.55rem',
              }}
            >
              Janice Maakaroun
            </div>
            <div
              className="mt-0.5 font-sans"
              style={{
                fontSize: '0.64rem',
                letterSpacing: '0.38em',
                textTransform: 'uppercase',
                color: 'var(--champagne)',
                fontWeight: 500,
              }}
            >
              Personal Organizer
            </div>
          </div>
        </a>

        <nav className="hidden xl:flex items-center gap-7">
          {navItems.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-[0.76rem] tracking-[0.18em] uppercase font-medium transition-colors"
              style={{ color: 'var(--warm-charcoal)' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--champagne)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--warm-charcoal)')}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden xl:block">
          <a
            href={WHATSAPP_TEXT_URL}
            target="_blank"
            rel="noreferrer"
            className="btn-primary"
            style={{ padding: '0.72rem 1.3rem', fontSize: '0.72rem' }}
          >
            <IconWhats size={15} />
            Agendar
          </a>
        </div>

        <button
          aria-label="Abrir menu"
          className="xl:hidden p-2 rounded-full"
          onClick={() => setOpen((v) => !v)}
          style={{ color: 'var(--warm-charcoal)' }}
        >
          <IconMenu open={open} />
        </button>
      </div>

      <div
        className={`xl:hidden overflow-hidden transition-[max-height,opacity] duration-500 ease-out ${
          open ? 'max-h-[640px] opacity-100' : 'max-h-0 opacity-0'
        }`}
        style={{
          background: 'rgba(247, 242, 234, 0.98)',
          backdropFilter: 'blur(12px)',
          borderTop: open ? '1px solid rgba(201,168,106,0.25)' : 'none',
        }}
      >
        <div className="container-lux py-6 flex flex-col gap-4">
          {navItems.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="text-[0.95rem] tracking-[0.18em] uppercase font-medium py-1"
              style={{ color: 'var(--warm-charcoal)' }}
            >
              {n.label}
            </a>
          ))}
          <div className="flex flex-col gap-3 pt-2">
            <a
              href={WHATSAPP_TEXT_URL}
              target="_blank"
              rel="noreferrer"
              className="btn-primary"
              onClick={() => setOpen(false)}
            >
              <IconWhats size={16} /> Agendar pelo WhatsApp
            </a>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noreferrer"
              className="btn-outline"
              onClick={() => setOpen(false)}
            >
              <IconInsta size={16} /> Instagram
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

/* -------- Hero -------- */
const Hero = () => (
  <section id="top" className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden">
    <div className="absolute inset-0 -z-10">
      <div
        className="w-full h-full"
        style={{
          background:
            'radial-gradient(ellipse at 80% 10%, rgba(201,168,106,0.22), transparent 55%),' +
            'radial-gradient(ellipse at 10% 90%, rgba(184,168,148,0.22), transparent 55%),' +
            'linear-gradient(180deg, #faf7f1 0%, #f3ead8 55%, #f7f2ea 100%)',
        }}
      />
    </div>

    <div className="container-lux relative">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <div className="flex items-center gap-3 mb-6">
              <span className="gold-divider" />
              <span className="eyebrow">Personal Organizer · Miami, Florida</span>
            </div>
          </Reveal>
          <Reveal delay={120}>
            <h1
              className="font-serif text-[2.5rem] sm:text-[3.1rem] md:text-[3.8rem] lg:text-[4.4rem] leading-[1.05]"
              style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
            >
              Organização com{' '}
              <em
                className="not-italic"
                style={{ color: 'var(--champagne)', fontStyle: 'italic', fontWeight: 500 }}
              >
                elegância
              </em>{' '}
              para uma casa mais leve, funcional e bonita.
            </h1>
          </Reveal>
          <Reveal delay={220}>
            <p
              className="mt-7 text-[1.05rem] md:text-[1.12rem] max-w-xl leading-relaxed"
              style={{ color: 'var(--muted-ink)' }}
            >
              Transformamos closets, gavetas, armários e ambientes em espaços práticos,
              sofisticados e fáceis de manter no dia a dia.
            </p>
          </Reveal>
          <Reveal delay={320}>
            <div className="mt-10 flex flex-col sm:flex-row flex-wrap gap-4">
              <a href={WHATSAPP_TEXT_URL} target="_blank" rel="noreferrer" className="btn-primary">
                <IconWhats size={16} />
                Agendar avaliação pelo WhatsApp
              </a>
              <a href="#servicos" className="btn-outline">
                Ver serviços <IconArrow />
              </a>
            </div>
          </Reveal>
          <Reveal delay={420}>
            <div
              className="mt-12 flex items-center gap-5 text-[0.74rem] tracking-[0.3em] uppercase"
              style={{ color: 'var(--muted-ink)' }}
            >
              <span>Discrição</span>
              <span className="w-1 h-1 rounded-full" style={{ background: 'var(--champagne)' }} />
              <span>Método</span>
              <span className="w-1 h-1 rounded-full" style={{ background: 'var(--champagne)' }} />
              <span>Estética</span>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={200}>
            <div className="relative">
              <div
                className="img-zoom rounded-[26px] overflow-hidden relative"
                style={{
                  boxShadow:
                    '0 40px 90px -35px rgba(42,38,35,0.42), 0 2px 0 rgba(201,168,106,0.35)',
                  border: '1px solid rgba(201,168,106,0.35)',
                  background: 'linear-gradient(135deg, #efe7d8, #d9cfbd)',
                }}
              >
                <SmartImage
                  src={IMG.heroCloset}
                  alt="Janice Maakaroun em closet de luxo organizado"
                  className="w-full h-[480px] md:h-[600px] object-cover"
                  loading="eager"
                  objectPosition="65% center"
                />
                <div
                  className="absolute inset-x-0 bottom-0 h-1/3 pointer-events-none"
                  style={{
                    background:
                      'linear-gradient(180deg, transparent 0%, rgba(42,38,35,0.4) 100%)',
                  }}
                />
                <div
                  className="absolute bottom-6 left-6 right-6 px-5 py-4 rounded-[14px] flex items-center justify-between"
                  style={{
                    background: 'rgba(255,255,255,0.95)',
                    backdropFilter: 'blur(8px)',
                    border: '1px solid rgba(201,168,106,0.3)',
                  }}
                >
                  <div>
                    <div className="eyebrow">Closet editorial</div>
                    <div
                      className="font-serif text-base md:text-lg mt-0.5"
                      style={{ color: 'var(--warm-charcoal)' }}
                    >
                      Por cor, tipo & ocasião
                    </div>
                  </div>
                  <span
                    className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ background: 'var(--champagne)', color: '#fff' }}
                  >
                    <IconArrow size={14} />
                  </span>
                </div>
              </div>
              <div
                className="hidden md:flex absolute -top-6 -left-6 items-center gap-3 px-4 py-3 rounded-full"
                style={{
                  background: '#fff',
                  border: '1px solid rgba(201,168,106,0.35)',
                  boxShadow: '0 18px 40px -20px rgba(42,38,35,0.3)',
                }}
              >
                <span className="w-2 h-2 rounded-full" style={{ background: 'var(--champagne)' }} />
                <span
                  className="text-[0.68rem] tracking-[0.3em] uppercase font-medium"
                  style={{ color: 'var(--warm-charcoal)' }}
                >
                  Atendimento sob medida
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

/* -------- Brand Promise Strip -------- */
const PromiseStrip = () => (
  <section
    className="py-14 md:py-20"
    style={{
      background: 'linear-gradient(180deg, var(--cream) 0%, #f1ead9 100%)',
      borderTop: '1px solid rgba(201,168,106,0.22)',
      borderBottom: '1px solid rgba(201,168,106,0.22)',
    }}
  >
    <div className="container-lux text-center">
      <Reveal>
        <div
          className="font-serif text-[2.1rem] md:text-[3rem] leading-tight"
          style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
        >
          Menos bagunça.{' '}
          <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>Mais leveza.</em>
        </div>
      </Reveal>
      <Reveal delay={150}>
        <div
          className="mt-7 flex items-center justify-center gap-4 md:gap-8 flex-wrap text-[0.78rem] md:text-[0.82rem] tracking-[0.28em] uppercase"
          style={{ color: 'var(--muted-ink)' }}
        >
          <span>Mais tempo</span>
          <span className="gold-divider" style={{ width: 28 }} />
          <span>Menos estresse</span>
          <span className="gold-divider" style={{ width: 28 }} />
          <span>Ambientes que funcionam</span>
        </div>
      </Reveal>
    </div>
  </section>
);

/* -------- About -------- */
const About = () => (
  <section id="sobre" className="py-24 md:py-36">
    <div className="container-lux">
      <div className="grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <Reveal>
            <div className="relative mx-auto max-w-md lg:max-w-none">
              <div
                className="absolute -inset-3 rounded-[28px] -z-10"
                style={{
                  background:
                    'linear-gradient(135deg, rgba(201,168,106,0.4), rgba(201,168,106,0.05))',
                }}
              />
              <div
                className="rounded-[22px] overflow-hidden relative"
                style={{
                  border: '2px solid rgba(201,168,106,0.55)',
                  boxShadow:
                    '0 35px 70px -30px rgba(42,38,35,0.4), inset 0 0 0 6px rgba(255,255,255,0.6)',
                  background: 'linear-gradient(135deg, #efe7d8, #d9cfbd)',
                }}
              >
                <SmartImage
                  src={IMG.janice}
                  alt="Janice Maakaroun — Personal Organizer"
                  className="w-full h-[560px] md:h-[640px] object-cover"
                  objectPosition="center 20%"
                  loading="eager"
                />
              </div>
              <div
                className="hidden md:block absolute -top-5 -right-5 px-5 py-3 rounded-full"
                style={{
                  background: '#fff',
                  border: '1px solid rgba(201,168,106,0.35)',
                  boxShadow: '0 18px 40px -20px rgba(42,38,35,0.25)',
                }}
              >
                <span className="eyebrow">Personal Organizer</span>
              </div>
              <div
                className="hidden md:block absolute -bottom-6 -left-6 px-5 py-4 rounded-[14px]"
                style={{
                  background: '#fff',
                  border: '1px solid rgba(201,168,106,0.3)',
                  boxShadow: '0 24px 50px -24px rgba(42,38,35,0.25)',
                }}
              >
                <div className="eyebrow">Método</div>
                <div
                  className="font-serif text-lg mt-0.5"
                  style={{ color: 'var(--warm-charcoal)' }}
                >
                  Estética · Função · Rotina
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal>
            <div className="flex items-center gap-3 mb-5">
              <span className="gold-divider" />
              <span className="eyebrow">Sobre a Janice</span>
            </div>
          </Reveal>
          <Reveal delay={100}>
            <h2
              className="font-serif text-[2.1rem] md:text-[3rem] leading-[1.1]"
              style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
            >
              Organização pensada para o seu{' '}
              <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>dia a dia</em>.
            </h2>
          </Reveal>
          <Reveal delay={180}>
            <div
              className="mt-7 space-y-5 text-[1.02rem] md:text-[1.06rem] leading-relaxed"
              style={{ color: 'var(--muted-ink)' }}
            >
              <p>
                A Janice Maakaroun é Personal Organizer especializada em transformar
                residências e espaços profissionais em ambientes mais funcionais, práticos e
                visualmente harmônicos.
              </p>
              <p>
                Com olhar cuidadoso para detalhes, estética e rotina, seu trabalho vai além de
                simplesmente arrumar. Cada projeto é pensado para facilitar o dia a dia do
                cliente, otimizar espaços e criar sistemas de organização bonitos, eficientes e
                fáceis de manter.
              </p>
            </div>
          </Reveal>
          <Reveal delay={260}>
            <div className="mt-10 grid grid-cols-3 gap-5 max-w-lg">
              {[
                { k: '+10', v: 'Anos de olhar apurado' },
                { k: '100%', v: 'Atendimento discreto' },
                { k: '1:1', v: 'Projeto personalizado' },
              ].map((s) => (
                <div key={s.v} className="text-center">
                  <div
                    className="font-serif text-3xl md:text-4xl"
                    style={{ color: 'var(--champagne)', fontWeight: 500 }}
                  >
                    {s.k}
                  </div>
                  <div
                    className="mt-2 text-[0.72rem] tracking-[0.22em] uppercase"
                    style={{ color: 'var(--muted-ink)' }}
                  >
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={340}>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a href={WHATSAPP_TEXT_URL} target="_blank" rel="noreferrer" className="btn-primary">
                <IconWhats size={16} /> Conversar com a Janice
              </a>
              <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="btn-outline">
                <IconInsta size={16} /> @janicemaakaroun
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

/* -------- Services -------- */
const services = [
  {
    title: 'Organização Residencial',
    desc: 'Projetos completos para casas e apartamentos, integrando estética e funcionalidade em cada ambiente.',
    img: IMG.servicoResidencial,
  },
  {
    title: 'Closets & Guarda-Roupas',
    desc: 'Sistemas visuais e práticos de categorização, com apresentação editorial de peças e acessórios.',
    img: IMG.servicoCloset,
  },
  {
    title: 'Bolsas, Sapatos & Acessórios',
    desc: 'Exposição refinada que valoriza cada peça, preservando formato, material e acabamento.',
    img: IMG.servicoBolsasSapatos,
  },
  {
    title: 'Gavetas & Dobras Funcionais',
    desc: 'Dobras precisas e divisórias personalizadas para uma rotina fluida e duradoura.',
    img: IMG.servicoGavetas,
  },
  {
    title: 'Mudanças & Pós-Mudança',
    desc: 'Planejamento, empacotamento consciente e montagem de ambientes prontos para viver.',
    img: IMG.servicoMudancas,
  },
  {
    title: 'Organização Empresarial',
    desc: 'Escritórios, estoques e áreas comerciais estruturados para produtividade e imagem de marca.',
    img: IMG.servicoEmpresarial,
  },
];

const Services = () => (
  <section id="servicos" className="py-24 md:py-36" style={{ background: '#fbf7ef' }}>
    <div className="container-lux">
      <Reveal>
        <div className="flex items-center gap-3 mb-5 justify-center">
          <span className="gold-divider" />
          <span className="eyebrow">Serviços</span>
          <span className="gold-divider" />
        </div>
      </Reveal>
      <Reveal delay={100}>
        <h2
          className="font-serif text-center text-[2.1rem] md:text-[3rem] leading-tight max-w-3xl mx-auto"
          style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
        >
          Projetos <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>sob medida</em>{' '}
          para cada rotina.
        </h2>
      </Reveal>
      <Reveal delay={180}>
        <p
          className="text-center mt-5 max-w-xl mx-auto text-[1rem] md:text-[1.05rem]"
          style={{ color: 'var(--muted-ink)' }}
        >
          Serviços premium de organização para quem valoriza tempo, discrição e um ambiente que
          realmente funciona.
        </p>
      </Reveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {services.map((s, i) => (
          <Reveal key={s.title} delay={i * 70}>
            <article className="lux-card overflow-hidden h-full flex flex-col">
              <div className="img-zoom relative">
                <SmartImage src={s.img} alt={s.title} className="w-full h-60 object-cover" />
                <div
                  className="absolute top-4 left-4 px-3 py-1 rounded-full text-[0.66rem] tracking-[0.22em] uppercase font-medium"
                  style={{
                    background: 'rgba(255,255,255,0.95)',
                    color: 'var(--champagne)',
                    backdropFilter: 'blur(6px)',
                  }}
                >
                  0{i + 1}
                </div>
              </div>
              <div className="p-7 md:p-8 flex-1 flex flex-col">
                <h3
                  className="font-serif text-[1.5rem] md:text-[1.6rem] leading-snug"
                  style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
                >
                  {s.title}
                </h3>
                <div className="mt-3 gold-line w-12" />
                <p
                  className="mt-4 text-[0.98rem] leading-relaxed flex-1"
                  style={{ color: 'var(--muted-ink)' }}
                >
                  {s.desc}
                </p>
                <a
                  href={WHATSAPP_TEXT_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-6 inline-flex items-center gap-2 text-[0.74rem] tracking-[0.22em] uppercase font-medium transition-colors"
                  style={{ color: 'var(--champagne)' }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--warm-charcoal)')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--champagne)')}
                >
                  Solicitar avaliação <IconArrow size={12} />
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

/* -------- How it works -------- */
const steps = [
  { t: 'Avaliação', d: 'Conversa inicial para entender rotina, estilo de vida e necessidades específicas do espaço.' },
  { t: 'Planejamento', d: 'Proposta personalizada com escopo, cronograma e sugestões de produtos quando necessário.' },
  { t: 'Organização', d: 'Execução completa com categorização, descarte consciente e sistemas visuais refinados.' },
  { t: 'Finalização', d: 'Ambientes entregues prontos para usar, com apresentação editorial e atenção aos detalhes.' },
  { t: 'Orientação', d: 'Instruções claras para manter a organização no dia a dia, com leveza e sem esforço.' },
];

const HowItWorks = () => (
  <section id="como-funciona" className="py-24 md:py-36">
    <div className="container-lux">
      <Reveal>
        <div className="flex items-center gap-3 mb-5 justify-center">
          <span className="gold-divider" />
          <span className="eyebrow">Como funciona</span>
          <span className="gold-divider" />
        </div>
      </Reveal>
      <Reveal delay={100}>
        <h2
          className="font-serif text-center text-[2.1rem] md:text-[3rem] leading-tight max-w-3xl mx-auto"
          style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
        >
          Um método{' '}
          <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>cuidadoso</em>, do
          primeiro contato ao último detalhe.
        </h2>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-5 gap-6">
        {steps.map((s, i) => (
          <Reveal key={s.t} delay={i * 80}>
            <div
              className="h-full p-7 md:p-8 rounded-[18px] flex flex-col transition-all"
              style={{
                background: '#fff',
                border: '1px solid rgba(201,168,106,0.22)',
                boxShadow: '0 18px 40px -28px rgba(42,38,35,0.18)',
              }}
            >
              <div className="step-number">0{i + 1}</div>
              <h3
                className="mt-3 font-serif text-xl md:text-[1.35rem]"
                style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
              >
                {s.t}
              </h3>
              <div className="mt-2 gold-line w-10" />
              <p
                className="mt-4 text-[0.96rem] leading-relaxed"
                style={{ color: 'var(--muted-ink)' }}
              >
                {s.d}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

/* -------- Portfolio -------- */
const gallery = [
  { label: 'Closets', sub: 'Categorização por cor', src: IMG.portClosetGradiente },
  { label: 'Camisas & Tricôs', sub: 'Dobras verticais', src: IMG.portCamisasVertical },
  { label: 'Gravatas', sub: 'Divisórias acrílicas', src: IMG.portGravatas },
  { label: 'Joias', sub: 'Apresentação editorial', src: IMG.portJoias },
  { label: 'Sapatos', sub: 'Por categoria', src: IMG.portSapatos },
  { label: 'Cintos', sub: 'Display acrílico', src: IMG.portCintos },
  { label: 'Maquiagem', sub: 'Penteadeira funcional', src: IMG.portMaquiagem },
  { label: 'Cozinha', sub: 'Louças alinhadas', src: IMG.portCozinha },
  { label: 'Despensa', sub: 'Potes etiquetados', src: IMG.portDespensa },
  { label: 'Talheres', sub: 'Gavetas premium', src: IMG.portTalheres },
  { label: 'Banheiro', sub: 'Cestos rotulados', src: IMG.portBanheiro },
  { label: 'Escritório', sub: 'Pastas categorizadas', src: IMG.portEscritorio },
];

const Portfolio = () => (
  <section id="portfolio" className="py-24 md:py-36" style={{ background: '#fbf7ef' }}>
    <div className="container-lux">
      <Reveal>
        <div className="flex items-center gap-3 mb-5 justify-center">
          <span className="gold-divider" />
          <span className="eyebrow">Portfólio visual</span>
          <span className="gold-divider" />
        </div>
      </Reveal>
      <Reveal delay={100}>
        <h2
          className="font-serif text-center text-[2.1rem] md:text-[3rem] leading-tight max-w-3xl mx-auto"
          style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
        >
          Um olhar{' '}
          <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>editorial</em> para cada
          ambiente.
        </h2>
      </Reveal>
      <Reveal delay={180}>
        <p
          className="text-center mt-5 max-w-xl mx-auto text-[1rem] md:text-[1.05rem]"
          style={{ color: 'var(--muted-ink)' }}
        >
          Projetos reais — closets, gavetas, cozinhas, escritórios e cada canto da casa
          transformados em espaços que funcionam.
        </p>
      </Reveal>

      <Reveal delay={260}>
        <div className="mt-10 flex items-center justify-center gap-3 max-w-2xl mx-auto">
          <span className="gold-divider" style={{ width: 22 }} />
          <p
            className="text-center font-serif italic text-[1rem] md:text-[1.1rem] leading-snug"
            style={{ color: 'var(--warm-charcoal)', letterSpacing: '0.005em' }}
          >
            Projetos reais, detalhes organizados e sistemas pensados para facilitar a rotina.
          </p>
          <span className="gold-divider" style={{ width: 22 }} />
        </div>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {gallery.map((g, i) => (
          <Reveal key={g.label} delay={i * 45}>
            <figure
              className="img-zoom relative rounded-[14px] overflow-hidden group"
              style={{
                border: '1px solid rgba(201,168,106,0.25)',
                background: 'linear-gradient(135deg, #efe7d8, #d9cfbd)',
                aspectRatio: '4 / 5',
              }}
            >
              <SmartImage
                src={g.src}
                alt={g.label}
                className="w-full h-full object-cover"
              />
              <figcaption
                className="absolute inset-x-0 bottom-0 p-4 flex items-end justify-between"
                style={{
                  background: 'linear-gradient(180deg, transparent 0%, rgba(42,38,35,0.78) 100%)',
                  color: '#fff',
                }}
              >
                <div>
                  <div className="font-serif text-[1.05rem] md:text-lg leading-tight">{g.label}</div>
                  <div
                    className="text-[0.65rem] tracking-[0.22em] uppercase mt-1"
                    style={{ color: 'rgba(255,255,255,0.85)' }}
                  >
                    {g.sub}
                  </div>
                </div>
                <span
                  className="text-[0.62rem] tracking-[0.25em] uppercase opacity-95 flex-shrink-0"
                  style={{ color: 'var(--champagne-soft)' }}
                >
                  Ver
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={300}>
        <div className="mt-12 text-center">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="btn-outline"
          >
            <IconInsta size={16} /> Ver mais no Instagram
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

/* -------- Antes & Depois -------- */
const beforeAfter = [
  {
    title: 'Closet de roupa de cama',
    desc: 'De prateleiras desorganizadas a sistemas dobrados por categoria, com peças sempre visíveis e fáceis de manter.',
    src: IMG.beforeAfterClosetCama,
  },
  {
    title: 'Geladeira & Conservação',
    desc: 'Embalagens descartadas, alimentos em recipientes transparentes etiquetados, com aproveitamento total do espaço.',
    src: IMG.beforeAfterGeladeira,
  },
];

const BeforeAfter = () => (
  <section id="antes-depois" className="py-24 md:py-36">
    <div className="container-lux">
      <Reveal>
        <div className="flex items-center gap-3 mb-5 justify-center">
          <span className="gold-divider" />
          <span className="eyebrow">Antes & Depois</span>
          <span className="gold-divider" />
        </div>
      </Reveal>
      <Reveal delay={100}>
        <h2
          className="font-serif text-center text-[2.1rem] md:text-[3rem] leading-tight max-w-3xl mx-auto"
          style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
        >
          A diferença que a{' '}
          <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>organização</em> faz.
        </h2>
      </Reveal>
      <Reveal delay={180}>
        <p
          className="text-center mt-5 max-w-xl mx-auto text-[1rem] md:text-[1.05rem]"
          style={{ color: 'var(--muted-ink)' }}
        >
          Transformações reais que mudam o uso diário do espaço — mais visual, mais prático, mais
          fácil de manter.
        </p>
      </Reveal>

      <div className="mt-14 grid lg:grid-cols-2 gap-7 md:gap-10">
        {beforeAfter.map((b, i) => (
          <Reveal key={b.title} delay={i * 100}>
            <div className="lux-card overflow-hidden h-full flex flex-col">
              <div className="relative">
                <SmartImage
                  src={b.src}
                  alt={`Antes e depois — ${b.title}`}
                  className="w-full h-[360px] md:h-[440px] object-cover"
                />
                <div
                  className="absolute top-4 left-4 px-3 py-1.5 rounded-full text-[0.66rem] tracking-[0.22em] uppercase font-medium"
                  style={{
                    background: 'rgba(42,38,35,0.85)',
                    color: 'var(--champagne-soft)',
                    backdropFilter: 'blur(6px)',
                  }}
                >
                  Transformação
                </div>
              </div>
              <div className="p-7 md:p-8">
                <h3
                  className="font-serif text-[1.4rem] md:text-[1.6rem] leading-snug"
                  style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
                >
                  {b.title}
                </h3>
                <div className="mt-3 gold-line w-12" />
                <p
                  className="mt-4 text-[0.98rem] leading-relaxed"
                  style={{ color: 'var(--muted-ink)' }}
                >
                  {b.desc}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

/* -------- For Whom -------- */
const audiences = [
  { t: 'Famílias com rotina intensa', d: 'Soluções que organizam o dia a dia de todos os moradores, com clareza e facilidade.' },
  { t: 'Casas e apartamentos de alto padrão', d: 'Projetos discretos e sofisticados, alinhados ao estilo e à estética do imóvel.' },
  { t: 'Clientes com muitas roupas, bolsas, sapatos e acessórios', d: 'Curadoria visual e categorização refinada para valorizar cada peça.' },
  { t: 'Pessoas em processo de mudança', d: 'Planejamento completo antes, durante e depois, com ambientes prontos para viver.' },
  { t: 'Empresários e profissionais com pouco tempo', d: 'Ganho de produtividade com espaços pessoais e profissionais sob medida.' },
  { t: 'Quem deseja uma rotina mais leve sem abrir mão da estética', d: 'Funcionalidade e beleza caminhando juntas em cada detalhe.' },
];

const ForWhom = () => (
  <section id="para-quem" className="py-24 md:py-36" style={{ background: '#fbf7ef' }}>
    <div className="container-lux">
      <Reveal>
        <div className="flex items-center gap-3 mb-5 justify-center">
          <span className="gold-divider" />
          <span className="eyebrow">Para quem</span>
          <span className="gold-divider" />
        </div>
      </Reveal>
      <Reveal delay={100}>
        <h2
          className="font-serif text-center text-[2.1rem] md:text-[3rem] leading-tight max-w-3xl mx-auto"
          style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
        >
          Para quem é este{' '}
          <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>serviço</em>?
        </h2>
      </Reveal>
      <Reveal delay={180}>
        <p
          className="text-center mt-5 max-w-xl mx-auto text-[1rem] md:text-[1.05rem]"
          style={{ color: 'var(--muted-ink)' }}
        >
          Um atendimento pensado para quem valoriza tempo, beleza e ambientes que realmente
          acompanham a rotina.
        </p>
      </Reveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
        {audiences.map((a, i) => (
          <Reveal key={a.t} delay={i * 60}>
            <div
              className="h-full p-7 md:p-8 rounded-[18px] flex flex-col transition-all relative overflow-hidden"
              style={{
                background: '#fff',
                border: '1px solid rgba(201,168,106,0.22)',
                boxShadow: '0 18px 40px -28px rgba(42,38,35,0.18)',
              }}
            >
              <div
                className="absolute top-0 left-0 right-0 h-1"
                style={{
                  background:
                    'linear-gradient(90deg, transparent, rgba(201,168,106,0.7), transparent)',
                }}
              />
              <div className="flex items-center gap-3 mb-4">
                <span
                  className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 font-serif"
                  style={{
                    background: 'linear-gradient(135deg, #efe7d8, #d9bf8a)',
                    color: 'var(--warm-charcoal)',
                    fontWeight: 500,
                    fontStyle: 'italic',
                    fontSize: '1.05rem',
                    border: '1px solid rgba(201,168,106,0.4)',
                  }}
                >
                  0{i + 1}
                </span>
                <div className="gold-line flex-1" />
              </div>
              <h3
                className="font-serif text-[1.25rem] md:text-[1.35rem] leading-snug"
                style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
              >
                {a.t}
              </h3>
              <p className="mt-3 text-[0.96rem] leading-relaxed" style={{ color: 'var(--muted-ink)' }}>
                {a.d}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

/* -------- Benefits -------- */
const benefits = [
  { t: 'Mais tempo', d: 'Você encontra tudo com mais facilidade.' },
  { t: 'Menos estresse', d: 'A rotina fica mais leve e previsível.' },
  { t: 'Mais beleza visual', d: 'Os ambientes ficam harmoniosos e elegantes.' },
  { t: 'Melhor aproveitamento de espaço', d: 'Cada área passa a ter uma função clara.' },
  { t: 'Manutenção mais simples', d: 'O sistema é criado para funcionar no dia a dia.' },
  { t: 'Mais qualidade de vida', d: 'Sua casa passa a trabalhar a seu favor.' },
];

const Benefits = () => (
  <section
    id="beneficios"
    className="py-24 md:py-36"
    style={{
      background: 'linear-gradient(180deg, #f7f0e0 0%, #f1ead9 50%, #efe5d0 100%)',
    }}
  >
    <div className="container-lux">
      <Reveal>
        <div className="flex items-center gap-3 mb-5 justify-center">
          <span className="gold-divider" />
          <span className="eyebrow">Benefícios</span>
          <span className="gold-divider" />
        </div>
      </Reveal>
      <Reveal delay={100}>
        <h2
          className="font-serif text-center text-[2.1rem] md:text-[3rem] leading-tight max-w-3xl mx-auto"
          style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
        >
          O que muda depois da{' '}
          <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>organização</em>?
        </h2>
      </Reveal>
      <Reveal delay={180}>
        <p
          className="text-center mt-5 max-w-xl mx-auto text-[1rem] md:text-[1.05rem]"
          style={{ color: 'var(--muted-ink)' }}
        >
          Resultados tangíveis que você percebe todos os dias — na sua rotina, na sua casa e no
          seu bem-estar.
        </p>
      </Reveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
        {benefits.map((b, i) => (
          <Reveal key={b.t} delay={i * 60}>
            <div
              className="h-full p-8 md:p-9 rounded-[18px] flex flex-col transition-all group"
              style={{
                background: 'rgba(255,255,255,0.8)',
                backdropFilter: 'blur(6px)',
                border: '1px solid rgba(201,168,106,0.28)',
                boxShadow: '0 20px 45px -28px rgba(42,38,35,0.22)',
              }}
            >
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center mb-5"
                style={{
                  background: 'linear-gradient(135deg, #e5cf9a 0%, #c9a86a 100%)',
                  boxShadow:
                    '0 8px 16px -6px rgba(201,168,106,0.55), inset 0 1px 0 rgba(255,255,255,0.4)',
                }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12l5 5L20 7"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <h3
                className="font-serif text-[1.35rem] md:text-[1.55rem] leading-snug"
                style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
              >
                {b.t}
              </h3>
              <div className="mt-3 gold-line w-10" />
              <p
                className="mt-4 text-[0.98rem] md:text-[1rem] leading-relaxed"
                style={{ color: 'var(--muted-ink)' }}
              >
                {b.d}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

/* -------- Service Area -------- */
const serviceAreas = [
  'Sunny Isles Beach (33160)',
  'Aventura',
  'Bal Harbour',
  'Surfside',
  'Bay Harbor Islands',
  'North Miami Beach',
  'North Miami',
  'Miami Beach',
  'Hallandale Beach',
  'Hollywood',
  'Golden Beach',
  'Miami',
];

const ServiceArea = () => (
  <section
    id="onde-atendemos"
    className="py-24 md:py-32"
    style={{ background: '#fbf7ef' }}
  >
    <div className="container-lux">
      <div className="grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="flex items-center gap-3 mb-5">
              <span className="gold-divider" />
              <span className="eyebrow">Onde atendemos</span>
            </div>
          </Reveal>
          <Reveal delay={100}>
            <h2
              className="font-serif text-[2rem] md:text-[2.8rem] leading-[1.12]"
              style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
            >
              Atendimento{' '}
              <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>premium</em> em
              Miami e arredores.
            </h2>
          </Reveal>
          <Reveal delay={180}>
            <p
              className="mt-6 leading-relaxed text-[1rem] md:text-[1.05rem]"
              style={{ color: 'var(--muted-ink)' }}
            >
              As regiões abaixo são onde a Janice atende com mais frequência. Para projetos
              especiais, ela viaja para outras cidades — basta enviar uma mensagem para
              avaliarmos juntos.
            </p>
          </Reveal>
          <Reveal delay={260}>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href={WHATSAPP_TEXT_URL}
                target="_blank"
                rel="noreferrer"
                className="btn-primary"
              >
                <IconWhats size={16} /> Verificar disponibilidade
              </a>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={150}>
            <div
              className="rounded-[20px] p-7 md:p-9"
              style={{
                background: '#fff',
                border: '1px solid rgba(201,168,106,0.25)',
                boxShadow: '0 22px 50px -28px rgba(42,38,35,0.22)',
              }}
            >
              <div className="flex items-center justify-between gap-4 mb-5">
                <div className="flex items-center gap-3">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="M12 22s7-7.58 7-13a7 7 0 1 0-14 0c0 5.42 7 13 7 13Z"
                      stroke="#c9a86a"
                      strokeWidth="1.6"
                    />
                    <circle cx="12" cy="9" r="2.5" stroke="#c9a86a" strokeWidth="1.6" />
                  </svg>
                  <div className="eyebrow">Regiões mais comuns</div>
                </div>
                <span
                  className="hidden sm:inline-block text-[0.62rem] tracking-[0.22em] uppercase font-medium px-3 py-1 rounded-full"
                  style={{
                    background: 'rgba(201,168,106,0.12)',
                    color: 'var(--champagne)',
                    border: '1px solid rgba(201,168,106,0.3)',
                  }}
                >
                  Sul da Flórida
                </span>
              </div>
              <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3">
                {serviceAreas.map((a) => (
                  <li
                    key={a}
                    className="flex items-start gap-3 text-[0.98rem]"
                    style={{ color: 'var(--warm-charcoal)' }}
                  >
                    <span
                      className="mt-2 w-1.5 h-1.5 rounded-full flex-shrink-0"
                      style={{ background: 'var(--champagne)' }}
                    />
                    <span>{a}</span>
                  </li>
                ))}
              </ul>

              {/* Travel-for-projects callout */}
              <div
                className="mt-7 rounded-[14px] p-5 md:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4"
                style={{
                  background:
                    'linear-gradient(135deg, rgba(201,168,106,0.08) 0%, rgba(217,191,138,0.14) 100%)',
                  border: '1px solid rgba(201,168,106,0.35)',
                }}
              >
                <div
                  className="w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{
                    background: 'linear-gradient(135deg, #e5cf9a 0%, #c9a86a 100%)',
                    boxShadow: '0 6px 14px -6px rgba(201,168,106,0.6)',
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="M2.5 12l9-9 9 9-2 2-2-2v8h-4v-5h-2v5H6v-8l-2 2-1.5-2Z"
                      stroke="#fff"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      transform="rotate(45 12 12)"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <div
                    className="font-serif text-[1.05rem] md:text-[1.15rem] leading-snug"
                    style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
                  >
                    Não viu sua região na lista?
                  </div>
                  <p
                    className="mt-1 text-[0.92rem] leading-relaxed"
                    style={{ color: 'var(--muted-ink)' }}
                  >
                    Mande uma mensagem mesmo assim. Para projetos especiais, a Janice viaja
                    para fora da área comum — vamos avaliar juntos a melhor forma de atender você.
                  </p>
                </div>
                <a
                  href={WHATSAPP_TEXT_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-primary flex-shrink-0"
                  style={{ padding: '0.75rem 1.3rem', fontSize: '0.72rem' }}
                >
                  <IconWhats size={14} /> Falar agora
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

/* -------- Legal modal (Privacidade & Termos) -------- */
const LegalModal = ({ open, onClose, type }) => {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    if (open) {
      document.addEventListener('keydown', onKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  const content = type === 'privacy' ? (
    <>
      <h3
        className="font-serif text-[1.8rem] md:text-[2.2rem] leading-tight"
        style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
      >
        Política de <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>Privacidade</em>
      </h3>
      <p className="mt-2 text-[0.78rem] tracking-[0.22em] uppercase" style={{ color: 'var(--muted-ink)' }}>
        Atualizada em 2026
      </p>
      <div className="mt-7 space-y-5 text-[0.96rem] leading-relaxed" style={{ color: 'var(--muted-ink)' }}>
        <p>
          A Janice Maakaroun preza pela privacidade e discrição de seus clientes. Este site é
          institucional e não realiza coleta automática de dados pessoais sensíveis.
        </p>
        <div>
          <strong style={{ color: 'var(--warm-charcoal)' }}>1. Informações de contato</strong>
          <p className="mt-2">
            Quando você clica nos botões de WhatsApp ou Instagram, é direcionado para os
            respectivos aplicativos, onde a comunicação acontece sob as políticas dessas
            plataformas. Os dados que você compartilhar voluntariamente conosco são utilizados
            exclusivamente para responder e atender o seu pedido.
          </p>
        </div>
        <div>
          <strong style={{ color: 'var(--warm-charcoal)' }}>2. Cookies & analytics</strong>
          <p className="mt-2">
            Podemos utilizar cookies de medição e análise de tráfego (como Google Analytics) com
            o objetivo de entender o comportamento de navegação e melhorar a experiência do
            site. Esses dados são anonimizados e agregados.
          </p>
        </div>
        <div>
          <strong style={{ color: 'var(--warm-charcoal)' }}>3. Confidencialidade dos projetos</strong>
          <p className="mt-2">
            Toda informação compartilhada durante a contratação ou execução de um projeto é
            tratada com sigilo absoluto. Imagens de projetos só são utilizadas em portfólio
            mediante autorização prévia do cliente.
          </p>
        </div>
        <div>
          <strong style={{ color: 'var(--warm-charcoal)' }}>4. Seus direitos</strong>
          <p className="mt-2">
            Você pode, a qualquer momento, solicitar exclusão, correção ou esclarecimento sobre
            seus dados entrando em contato pelo WhatsApp +1 (305) 910-6323 ou pelo Instagram
            @janicemaakaroun.
          </p>
        </div>
      </div>
    </>
  ) : (
    <>
      <h3
        className="font-serif text-[1.8rem] md:text-[2.2rem] leading-tight"
        style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
      >
        Termos de <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>uso</em>
      </h3>
      <p className="mt-2 text-[0.78rem] tracking-[0.22em] uppercase" style={{ color: 'var(--muted-ink)' }}>
        Atualizada em 2026
      </p>
      <div className="mt-7 space-y-5 text-[0.96rem] leading-relaxed" style={{ color: 'var(--muted-ink)' }}>
        <p>
          Este site tem caráter institucional e apresenta os serviços de Personal Organizer
          oferecidos por Janice Maakaroun. Ao navegar, você concorda com os termos abaixo.
        </p>
        <div>
          <strong style={{ color: 'var(--warm-charcoal)' }}>1. Conteúdo</strong>
          <p className="mt-2">
            Todas as imagens, textos, marcas e identidade visual são de propriedade exclusiva
            de Janice Maakaroun. Reprodução, cópia ou uso comercial sem autorização é proibido.
          </p>
        </div>
        <div>
          <strong style={{ color: 'var(--warm-charcoal)' }}>2. Serviços</strong>
          <p className="mt-2">
            Os serviços oferecidos são totalmente personalizados. Cada projeto é precedido por
            uma avaliação para entendimento da rotina, espaço e necessidades. Valores,
            cronograma e escopo são alinhados em proposta individual.
          </p>
        </div>
        <div>
          <strong style={{ color: 'var(--warm-charcoal)' }}>3. Agendamento</strong>
          <p className="mt-2">
            O agendamento é feito diretamente pelo WhatsApp ou Instagram. Confirmações,
            remarcações e cancelamentos seguem a política combinada em cada proposta.
          </p>
        </div>
        <div>
          <strong style={{ color: 'var(--warm-charcoal)' }}>4. Limitação de responsabilidade</strong>
          <p className="mt-2">
            Este site é fornecido "como está". Apesar de todo o cuidado com as informações,
            podem ocorrer eventuais imprecisões. Para confirmações sobre serviços e
            atendimento, consulte sempre a Janice diretamente.
          </p>
        </div>
        <div>
          <strong style={{ color: 'var(--warm-charcoal)' }}>5. Foro</strong>
          <p className="mt-2">
            Eventuais questões serão tratadas amigavelmente entre as partes, prioritariamente.
          </p>
        </div>
      </div>
    </>
  );

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end md:items-center justify-center p-0 md:p-6"
      style={{ background: 'rgba(42,38,35,0.55)', backdropFilter: 'blur(6px)' }}
      onClick={onClose}
    >
      <div
        className="relative w-full md:max-w-2xl max-h-[92vh] overflow-y-auto rounded-t-[24px] md:rounded-[22px]"
        style={{
          background: 'var(--cream)',
          border: '1px solid rgba(201,168,106,0.35)',
          boxShadow: '0 40px 80px -30px rgba(42,38,35,0.5)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          aria-label="Fechar"
          onClick={onClose}
          className="absolute top-4 right-4 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:rotate-90"
          style={{
            background: '#fff',
            border: '1px solid rgba(201,168,106,0.35)',
            color: 'var(--warm-charcoal)',
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
        </button>
        <div className="p-7 md:p-10">{content}</div>
      </div>
    </div>
  );
};

/* -------- FAQ -------- */
const faqs = [
  { q: 'Quais serviços a Janice oferece?', a: 'Organização residencial e empresarial completa: closets, guarda-roupas, gavetas, bolsas, sapatos, acessórios, cozinhas, escritórios, mudanças e pós-mudança. Cada projeto é totalmente personalizado.' },
  { q: 'O que faz uma Personal Organizer?', a: 'Uma Personal Organizer cria sistemas de organização funcionais e estéticos, pensados para facilitar sua rotina e serem mantidos no dia a dia com leveza e simplicidade.' },
  { q: 'Os projetos são realmente personalizados?', a: 'Sim. Cada projeto começa com uma avaliação cuidadosa para entender rotina, estilo de vida e preferências. A solução é desenhada exclusivamente para você e para o seu espaço.' },
  { q: 'Como manter a organização depois do serviço?', a: 'Ao final, você recebe orientações claras e práticas sobre como manter cada ambiente, além de sugestões de hábitos simples para preservar o resultado por muito tempo.' },
  { q: 'Como agendar uma avaliação?', a: 'O agendamento é feito diretamente pelo WhatsApp ou Instagram. Entre em contato para alinharmos uma conversa inicial, entender suas necessidades e agendar a visita.' },
];

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="py-24 md:py-36">
      <div className="container-lux">
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="flex items-center gap-3 mb-5">
                <span className="gold-divider" />
                <span className="eyebrow">Perguntas frequentes</span>
              </div>
            </Reveal>
            <Reveal delay={100}>
              <h2
                className="font-serif text-[2.1rem] md:text-[3rem] leading-[1.12]"
                style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
              >
                Tudo que você precisa saber antes de{' '}
                <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>começar</em>.
              </h2>
            </Reveal>
            <Reveal delay={180}>
              <p
                className="mt-6 leading-relaxed text-[1rem] md:text-[1.05rem]"
                style={{ color: 'var(--muted-ink)' }}
              >
                Se ainda tiver dúvidas, será um prazer responder pessoalmente. O atendimento é
                próximo, discreto e sob medida para a sua rotina.
              </p>
              <a
                href={WHATSAPP_TEXT_URL}
                target="_blank"
                rel="noreferrer"
                className="btn-primary mt-7"
              >
                <IconWhats size={16} /> Falar com a Janice
              </a>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal>
              <div
                className="rounded-[20px] p-2 md:p-4"
                style={{ background: '#fff', border: '1px solid rgba(201,168,106,0.25)' }}
              >
                {faqs.map((f, i) => (
                  <div key={f.q} className="faq-item">
                    <button
                      className="w-full flex items-center justify-between gap-6 text-left p-5 md:p-6"
                      onClick={() => setOpen(open === i ? -1 : i)}
                      aria-expanded={open === i}
                    >
                      <span
                        className="font-serif text-[1.12rem] md:text-[1.3rem]"
                        style={{ color: 'var(--warm-charcoal)', fontWeight: 500 }}
                      >
                        {f.q}
                      </span>
                      <span
                        className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-transform"
                        style={{
                          background: open === i ? 'var(--champagne)' : 'transparent',
                          color: open === i ? '#fff' : 'var(--warm-charcoal)',
                          border: '1px solid rgba(201,168,106,0.45)',
                          transform: open === i ? 'rotate(45deg)' : 'rotate(0)',
                        }}
                      >
                        <IconPlus />
                      </span>
                    </button>
                    <div
                      className="overflow-hidden transition-[max-height,opacity] duration-500 ease-out"
                      style={{
                        maxHeight: open === i ? 400 : 0,
                        opacity: open === i ? 1 : 0,
                      }}
                    >
                      <p
                        className="px-5 md:px-6 pb-6 leading-relaxed text-[0.98rem] md:text-[1rem]"
                        style={{ color: 'var(--muted-ink)' }}
                      >
                        {f.a}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

/* -------- Final CTA -------- */
const FinalCTA = () => (
  <section
    className="relative py-28 md:py-40 overflow-hidden"
    style={{
      background:
        'linear-gradient(135deg, #221e1b 0%, #2a2623 40%, #3a3126 75%, #4a3c27 100%)',
      color: 'var(--off-white)',
    }}
  >
    <div
      className="absolute inset-0 pointer-events-none"
      style={{
        background:
          'radial-gradient(ellipse at 20% 10%, rgba(201,168,106,0.18), transparent 55%),' +
          'radial-gradient(ellipse at 80% 90%, rgba(201,168,106,0.15), transparent 60%)',
      }}
    />
    <div className="container-lux text-center relative">
      <Reveal>
        <div className="flex items-center gap-3 justify-center mb-6">
          <span className="inline-block w-14 h-px" style={{ background: 'var(--champagne)' }} />
          <span className="eyebrow" style={{ color: 'var(--champagne-soft)' }}>
            Vamos começar
          </span>
          <span className="inline-block w-14 h-px" style={{ background: 'var(--champagne)' }} />
        </div>
      </Reveal>
      <Reveal delay={100}>
        <h2
          className="font-serif text-[2.4rem] md:text-[3.8rem] leading-[1.08] max-w-3xl mx-auto"
          style={{ fontWeight: 500 }}
        >
          Vamos organizar o seu{' '}
          <em style={{ color: 'var(--champagne)', fontStyle: 'italic' }}>espaço</em>?
        </h2>
      </Reveal>
      <Reveal delay={180}>
        <p
          className="mt-7 max-w-xl mx-auto leading-relaxed text-[1.02rem] md:text-[1.08rem]"
          style={{ color: 'rgba(250,247,241,0.78)' }}
        >
          Atendimento personalizado, discreto e sob medida. Entre em contato para uma avaliação e
          receba uma proposta pensada exclusivamente para a sua rotina.
        </p>
      </Reveal>
      <Reveal delay={260}>
        <div className="mt-11 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WHATSAPP_TEXT_URL}
            target="_blank"
            rel="noreferrer"
            className="btn-primary"
            style={{
              background: 'var(--champagne)',
              borderColor: 'var(--champagne)',
              color: '#2a2623',
            }}
          >
            <IconWhats size={16} /> Agendar pelo WhatsApp
          </a>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="btn-outline"
            style={{
              color: 'var(--off-white)',
              borderColor: 'rgba(250,247,241,0.55)',
            }}
          >
            <IconInsta size={16} /> Enviar mensagem no Instagram
          </a>
        </div>
      </Reveal>
      <Reveal delay={340}>
        <div
          className="mt-14 flex items-center justify-center gap-6 text-[0.72rem] tracking-[0.3em] uppercase"
          style={{ color: 'rgba(250,247,241,0.55)' }}
        >
          <span>Miami, Florida</span>
          <span className="w-1 h-1 rounded-full" style={{ background: 'var(--champagne)' }} />
          <span>Sunny Isles 33160</span>
          <span className="w-1 h-1 rounded-full" style={{ background: 'var(--champagne)' }} />
          <span>Atendimento privado</span>
        </div>
      </Reveal>
    </div>
  </section>
);

/* -------- Footer -------- */
const Footer = ({ onOpenLegal }) => (
  <footer
    className="pt-20 pb-10"
    style={{
      background: 'var(--cream)',
      borderTop: '1px solid rgba(201,168,106,0.25)',
    }}
  >
    <div className="container-lux">
      <div className="grid md:grid-cols-3 gap-10 md:gap-14">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <Monogram size={44} />
            <div>
              <div
                className="font-serif text-[1.45rem] font-medium"
                style={{ color: 'var(--warm-charcoal)' }}
              >
                Janice Maakaroun
              </div>
              <div className="eyebrow mt-0.5">Personal Organizer</div>
            </div>
          </div>
          <p
            className="mt-5 max-w-xs leading-relaxed text-[0.98rem]"
            style={{ color: 'var(--muted-ink)' }}
          >
            Organização com elegância, funcionalidade e propósito.
          </p>
        </div>

        <div>
          <div className="eyebrow mb-5">Contato</div>
          <ul
            className="space-y-3.5 text-[0.98rem]"
            style={{ color: 'var(--warm-charcoal)' }}
          >
            <li>
              <a
                href={WHATSAPP_TEXT_URL}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2.5 hover:opacity-70 transition-opacity"
              >
                <IconWhats size={16} /> +1 (305) 910-6323
              </a>
            </li>
            <li>
              <a
                href={EMAIL_URL}
                className="inline-flex items-center gap-2.5 hover:opacity-70 transition-opacity break-all"
              >
                <IconMail size={16} /> {EMAIL_ADDRESS}
              </a>
            </li>
            <li>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2.5 hover:opacity-70 transition-opacity"
              >
                <IconInsta size={16} /> @janicemaakaroun
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-5">Navegação</div>
          <ul className="space-y-3 text-[0.98rem]" style={{ color: 'var(--warm-charcoal)' }}>
            {[
              { l: 'Sobre', h: '#sobre' },
              { l: 'Serviços', h: '#servicos' },
              { l: 'Como funciona', h: '#como-funciona' },
              { l: 'Portfólio', h: '#portfolio' },
              { l: 'Antes & Depois', h: '#antes-depois' },
              { l: 'Para quem', h: '#para-quem' },
              { l: 'Benefícios', h: '#beneficios' },
              { l: 'Atendimento', h: '#onde-atendemos' },
              { l: 'FAQ', h: '#faq' },
            ].map((i) => (
              <li key={i.h}>
                <a href={i.h} className="hover:opacity-70 transition-opacity">
                  {i.l}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-14 gold-line" />
      <div
        className="mt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[0.74rem] tracking-[0.2em] uppercase"
        style={{ color: 'var(--muted-ink)' }}
      >
        <div>© 2026 Janice Maakaroun. Todos os direitos reservados.</div>
        <div className="flex items-center gap-5 flex-wrap justify-center">
          <button
            onClick={() => onOpenLegal('privacy')}
            className="hover:opacity-100 transition-opacity"
            style={{ color: 'var(--muted-ink)', opacity: 0.85 }}
          >
            Privacidade
          </button>
          <span style={{ color: 'rgba(201,168,106,0.5)' }}>·</span>
          <button
            onClick={() => onOpenLegal('terms')}
            className="hover:opacity-100 transition-opacity"
            style={{ color: 'var(--muted-ink)', opacity: 0.85 }}
          >
            Termos
          </button>
          <span style={{ color: 'rgba(201,168,106,0.5)' }}>·</span>
          <span>Miami, Florida</span>
        </div>
      </div>
    </div>
  </footer>
);

/* -------- Floating WhatsApp -------- */
const FloatingWhats = () => (
  <a
    href={WHATSAPP_TEXT_URL}
    target="_blank"
    rel="noreferrer"
    aria-label="WhatsApp"
    className="fixed z-40 bottom-20 right-4 md:bottom-6 md:right-[210px] rounded-full flex items-center justify-center transition-all hover:scale-110"
    style={{
      width: 56,
      height: 56,
      background: 'linear-gradient(135deg, #d9bf8a 0%, #c9a86a 100%)',
      color: '#fff',
      boxShadow:
        '0 16px 36px -12px rgba(201,168,106,0.7), inset 0 1px 0 rgba(255,255,255,0.35)',
    }}
  >
    <IconWhats size={24} />
  </a>
);

/* -------- App -------- */
export default function App() {
  const [legal, setLegal] = useState(null); // 'privacy' | 'terms' | null
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <PromiseStrip />
        <About />
        <Services />
        <HowItWorks />
        <Portfolio />
        <BeforeAfter />
        <ForWhom />
        <Benefits />
        <ServiceArea />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer onOpenLegal={setLegal} />
      <FloatingWhats />
      <LegalModal open={!!legal} type={legal} onClose={() => setLegal(null)} />
    </div>
  );
}
